import { smrApi } from '@/utils/axios-config'

const apiBase = 'gis-packaginglist';

export default {
    search(data) {
        return smrApi.post(`${apiBase}/packaging-list/search`, data);
    },
}